export default __webpack_public_path__ + "images/google2FA_e041bd.svg";